import { render, staticRenderFns } from "./CaseMessage.vue?vue&type=template&id=0ad6ccd6"
import script from "./CaseMessage.vue?vue&type=script&lang=js"
export * from "./CaseMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports